import React from 'react';
import './EasterEggPage.css';
import './StockAnalyzer.css';
import { ReactComponent as ArrowUpIcon } from '../assets/arrow-up.svg';
import wechatImage from '../assets/wechat.png';

interface EasterEggPageProps {
  onBackToInput: () => void;
}

export default function EasterEggPage({ onBackToInput }: EasterEggPageProps) {
  return (
    <div className="easter-egg-page">
      {/* 蓝色背景容器 */}
      <div className="easter-egg-container">
        {/* 主要内容 */}
        <div className="easter-egg-content">
          <div className="easter-egg-text-1">
            能点进这个页面，说明你不仅好奇，还够机灵！
          </div>
          
          <div className="easter-egg-text-2">
            想看看我是怎么把这个异常页面搞出来的？
          </div>
          
          <div className="easter-egg-text-3">
            其实想告诉你：
          </div>
          
          <div className="easter-egg-text-4">
            产品需求、视觉、交互、前端、后端、测试、上线
          </div>
          
          <div className="easter-egg-text-5">
            一个人完成，顺便验证了 AI 现在到底能帮上多少忙
          </div>
          
          <div className="easter-egg-text-6">
            结果是肯定的，远超出自己能力边界的输出
          </div>
          
          <div className="easter-egg-text-7">
            如果你也爱折腾、爱研究
          </div>
          
          <div className="easter-egg-text-8">
            一起出来喝咖啡聊聊？
          </div>
          
          <div className="easter-egg-text-9">
            或许下一次「彩蛋」，就是咱们一起做的
          </div>
          
          {/* 头像 - 改为正方形 */}
          <div className="easter-egg-avatar">
            <div className="avatar-placeholder square">
              <img 
                src={wechatImage} 
                alt="微信二维码" 
                className="avatar-image"
              />
            </div>
          </div>
          
        </div>
        
        {/* 返回首页按钮 - 与结果页样式一致 */}
        <div className="button-section button-section-moved">
          <button
            onClick={onBackToInput}
            className="calculate-button"
          >
            <div className="button-circle">
              <ArrowUpIcon style={{ fontSize: '16px' }} />
            </div>
            <span className="button-text">
              返回首页
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}